<script setup lang="ts">
import type { TutorCategoryType } from '@entities/tutor'

import { RowInfo } from '@shared/ui/other'

import { usePaymentPolicyRow } from '../model/payment-policy-row.hook'

defineOptions({
  name: 'PaymentPolicyRow',
})

const props = defineProps<{
  title: string
  category: TutorCategoryType
}>()

const { refValue } = usePaymentPolicyRow({ category: props.category })
</script>

<template>
  <RowInfo
    :title="title"
    :value="refValue"
  />
</template>
